import Vue from 'vue'
import VueRouter from 'vue-router'
import * as modules from './modules'
import store from '@/store'
import i18n from '@/plugins/i18n'
import { localize } from 'vee-validate'
import ability from '@/store/ability'
import { MENU_ROUTE_PERMISSION, MODULES } from '@/constants'
import moment from 'moment'

Vue.use(VueRouter)

let autoLoadModules = []
Object.values(modules).forEach(mods => {
  autoLoadModules = [...autoLoadModules, ...mods]
})

const routes = [
  ...autoLoadModules,
  {
    path: '/',
    name: 'root',
    component: {
      functional: true,
      render: (cE, context) => {
        if (!store.getters['auth/isAuth']) {
          context.parent.$router.replace({ name: 'auth.login' })
        } else {
          if (ability.can(MENU_ROUTE_PERMISSION, MODULES.DASHBOARD)) {
            context.parent.$router.replace({ name: 'dashboard' })
          } else {
            context.parent.$router.replace({ name: 'fusebox.index' })
          }
        }
      }
    }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    meta: {
      title: 'general.dashboard',
      requiresAuth: true,
      permission: MODULES.DASHBOARD
    },
    component: () => import('../views/Dashboard.vue')
  },
  {
    path: '/search',
    name: 'search',
    requiresAuth: true,
    component: () => import('@/views/Search.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  if (store.state.language.language && store.state.language.language !== i18n.locale) {
    i18n.locale = store.state.language.language
    localize(i18n.locale)
    moment.locale(i18n.locale)
  }
  document.title = i18n.tc(to.meta.title) + ' | Fusebox.online - circuit breaker mapping made easy'

  if (to.matched.some(record => record.meta.requiresAuth)) {
    // TODO: Dynamically set title
    document.title = 'Fusebox.online - circuit breaker mapping made easy'
    if (store.getters['auth/isAuth'] === false) {
      next({ name: 'auth.login', query: { intended: to.matched[0].path } })
    } else {
      if (typeof to.matched[0].meta.permission !== 'undefined' && !checkPermission(to.matched[0].meta.permission)) {
        next({ name: 'error.accessDenied' })
      } else if (to.matched[0].meta.permission === MODULES.PAYMENT && store.getters['auth/user'].is_company_user === false) {
        next({ name: 'error.accessDenied' })
      } else {
        next()
      }
    }
  } else if (to.matched.some(record => record.meta.redirectIfAuth) && store.getters['auth/isAuth'] !== false) {
    next({ name: 'dashboard' })
  } else {
    next()
  }
})

const checkPermission = permModule => ability.can(MENU_ROUTE_PERMISSION, permModule)

export default router
